import stopsMarker from "@/assets/map/stopsImage.png";
import defaultMarker from "@/assets/map/default.png";

const iconsMap = {
  other: stopsMarker,
  default: defaultMarker,
};

export { iconsMap, defaultMarker };
